<div>
    <div class="col-sm-12 pb-2 border-bottom table-filter">
        <form [formGroup]="form" (submit)="search(form)" class="d-flex flex-row align-items-center flex-wrap">
        <fieldset class="d-contents">
            <legend class="visually-hidden">Filter and search requests</legend>
            <edl-floating-label-container *ngIf="canViewRequestType" label="Request type"   for="requestTypeSelector" class="w-auto mt-2 mb-2 me-sm-2 mb-sm-0">
                <select
                    id="requestTypeSelector"
                    (change)="onRequestTypeChange($event)"
                    title="Request Type"
                    class="request-type-selector form-select"
                    formControlName="requestType">
                    <option [value]="RequestTypeFilter.MyRequests" selected="true">My Requests</option>
                    <option [value]="RequestTypeFilter.ManagedRequests">Managed Requests</option>
                </select>
            </edl-floating-label-container>
            <edl-floating-label-container   label="Tag" for="tagFilterSelector" class="w-auto mt-2 mb-2 me-sm-2 mb-sm-0">
                <select id="tagFilterSelector" (mousedown)="onSelectMouseDown()" (keydown)="handleTagKeydown($event)" (change)="onTagChange($event)" title="Tag Filter" name="Tag Filter" class="tags-selector form-select tag-filter" formControlName="filterTagBy">
                    <option value="0">Select Tag</option>
                    <option *ngFor="let tagValue of tags" [value]="tagValue.TagID">
                        {{ tagValue.Tag.length > 30 ? (tagValue.Tag | slice:0:30) + '…' : tagValue.Tag }}
                    </option>
                </select>
            </edl-floating-label-container>
            <edl-floating-label-container   label="Status" for="statusFilterSelector" class="w-auto mt-2 mb-2 me-sm-2 mb-sm-0">
                <select id="statusFilterSelector" (mousedown)="onSelectMouseDown()" (change)="onStatusChange($event)" (keydown)="handleStatusKeydown($event)" title="Status Filter" role="listbox" name="Status Filter" class="status-selector form-select" formControlName="filterStatusBy">
                    <option *ngFor="let status of filterStatuses" [value]="status.value">{{ status.label }}</option>
                </select>
            </edl-floating-label-container>

            <edl-floating-label-container label="Search" for="requestsTabSearchInput" class="w-auto mt-2">
                <div class="input-group">
                    <input id="requestsTabSearchInput" type="text" class="form-control search-by-input" formControlName="searchBy" (keydown)="handleSearchKeydown($event)" />
                    <button title="Search" type="submit" class="input-group-text btn btn-info" aria-label="Search"><i class="fas fa-search" aria-hidden="true"></i></button>
                </div>
            </edl-floating-label-container>
            <button title="Clear Filters" type="button" class="btn btn-cancel ms-2 mt-2 d-flex align-items-center filter-btn-height" tabindex="0" (click)="clearFiltersAndRefresh()">
                <i class="fas fa-times" aria-hidden="true"></i> Clear
            </button>
        </fieldset>
            <div class="align-items-left mt-2">
                <a class="btn btn-secondary ms-2 d-flex align-items-center filter-btn-height" uiSref="authenticated.requests.open-requests" [uiParams]="{ page: 1, submitOnBehalfUserId: user.UserID }">
                    <span *ngIf="!isUser"><i class="fas fa-user-plus" aria-hidden="true"></i> Submit on Behalf of</span>
                    <span *ngIf="isUser">Available Requests</span>
                </a>
            </div>
            <div class="requests-btn-container align-items-right mt-2">
                <a class="btn btn-cancel ms-2 d-flex align-items-center filter-btn-height"
                    *ngIf="showReturnToAllUsersProgress()"
                (click)="clickReturnToAllUsersProgress()">
                    <i class="fas fa-arrow-left me-1" aria-hidden="true"></i>Return to All Users' Progress
                </a>
            </div>             
        </form>           
    </div>

    <div class="overflow-box">
        <edl-requests-tab-list
            [requests]="pagedResponse.Results"
            [isUser]="isUser"
            (onViewSubmissions)="showSubmissions($event)">
        </edl-requests-tab-list>
    </div>

    <div class="content">
        <comply-pagination [pagedResponse]="pagedResponse" [pageSizes]="[20]"></comply-pagination>
    </div>
</div>